import HoldingStatus from 'src/app/shared/enums/HoldingStatus.enum';
import HoldingDiscriminator from 'src/app/shared/enums/HoldingDiscriminator.enum';
import HoldingType from 'src/app/shared/enums/HoldingType.enum';
import {CurrencyModel} from 'src/app/shared/models/CurrencyModel';
import {UnitBusinessApplicationReqRes} from 'src/app/shared/models/unit-bank-account/UnitBusinessApplicationReqRes.model';
import UnitApplicationStatus from 'src/app/shared/enums/unit-bank-account/UnitApplicationStatus.enum';
import {OpportunityDto} from './OpportunityDto.model';

export class GpHoldingListItemReqRes {
  discriminator: HoldingDiscriminator;
  id: number;
  name: string;
  status: HoldingStatus;
  isPrivate: boolean;
  holdingType: HoldingType;
  exposure: number;
  totalInvestedInHoldingByFund: number;
  ownership: number;
  initialCurrency: CurrencyModel;
  isDeletable = false;
  lastDistributingEntityId: number;
  unitApplicationId: number;
  unitApplicationStatus: UnitApplicationStatus;
  unitApplications: UnitBusinessApplicationReqRes[];
  customFields;

  isExample: boolean;
  investNow: boolean;

  public opportunityId: number;
  public opportunity: OpportunityDto;

  // for ui only
  public checked = false;
  public hover = false;
}
